import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const shuffler = defineConnector({
  identifier: "shuffler",
  name: "Shuffler",
  tagLine: "Security orchestration",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://shuffler\\.io/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Shuffler](https://shuffler.io/), go to **Settings → API Keys** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://shuffler.io/api/v1/users/getusers",
  },
});
